var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* eslint-disable class-methods-use-this */
import LuxonUtils from '@date-io/luxon';
var PickerConfig = /** @class */ (function (_super) {
    __extends(PickerConfig, _super);
    function PickerConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PickerConfig.prototype.getDatePickerHeaderText = function (date) {
        return date.toFormat('M月d日');
    };
    PickerConfig.prototype.getYearText = function (date) {
        return date.toFormat('y年');
    };
    PickerConfig.prototype.getYearHeaderText = function (date) {
        return date.toFormat('y年');
    };
    PickerConfig.prototype.getMonthText = function (date) {
        return date.toFormat('M月');
    };
    PickerConfig.prototype.getCalendarHeaderText = function (date) {
        return date.toFormat('y年M月');
    };
    PickerConfig.prototype.getMeridiemText = function (ampm) {
        return ampm === 'am' ? '午前' : '午後';
    };
    return PickerConfig;
}(LuxonUtils));
export { PickerConfig };
